import { createSelector } from '@reduxjs/toolkit';
import { selectHasDecoration } from 'shared/selectors/jsonQuery';

const OPTIONS = [
  { label: 'Неважно', value: null },
  { label: 'Без отделки', value: false },
  { label: 'С отделкой', value: true },
];

export const selectFinishingFilter = createSelector(selectHasDecoration, value => ({
  label: 'Отделка',
  value: [value],
  options: OPTIONS,
}));
